module.exports = __webpack_public_path__ + "static/media/carousel-img01.bb8726f8.png";